import React, { Component } from "react";
import ArticleContainer from "./ArticleContainer";
import SliderContainer from "./Slider/SliderContainer";
import OneColumnPage from "../layouts/OneColumnPage";
import TwoColumnPage from "../layouts/TwoColumnPage";
import TwoColumnFullWidthHeaderPage from "../layouts/TwoColumnFullWidthHeaderPage";
import SliderTestContainer from "./SliderTestSection/SliderTestContainer";
import SolutionContainer from "./SolutionSection/SolutionContainer";
import VastPROLogoContainer from "./LogoSection/VastPROLogoContainer";
import CssPage from "../layouts/CssPage";
import CssContent from "./CssContent";
import HeaderCbOSE from "./HeaderCarolina/CbOSEHeaderContainer";
import FormPlugin from "./Forms/FormPlugin";
import FormTemplatePlugin from "./Forms/FormTemplatePlugin";
import customSliderContainer from "./CustomSliderRendering/CustomSliderContainer";
import CbHomeTemplate from "../layouts/CbHomeTemplate";
import PageSlotContainer from "../layouts/PageSlotContainer";
import ContentRuleFolder from "./ContentFolder/ContentRuleFolder";
import FooterContainer from "./FooterCarolina/CbOSEFooterContainer";
import ProductDescriptionContainer from "./ProductDescriptionSection/ProductDescriptionContainer";
import RawHtmlContainer from "./RawHtmlContainer";
import CategoryListingContainer from "./CategoryListingSection/CategoryListingContainer";
import ResultsContainer from "./PlpSection/ResultsContainer";
import BreadCrumbsContainer from "./BreadCrumbs/BreadCrumbsContainer";
import ProductDetailsContainer from "./PdpSection/ProductDetailsContainer";
import FacetsContainer from "./Facets/FacetsContainer";
import CbOSEMainContainer from "./CbOSEHomePage/CbOSEMainContainer";
import HtmlRawContainer from "./HtmlRawContainer/HtmlRawContainer";
import SelectedCrumbContainer from "./BreadCrumbs/SelectedCrumbContainer";
import CategoryNameContainer from "./CategoryNameContainer/CategoryNameContainer";
import ZeroResultContainer from "./PlpSection/ZeroResultContainer";
import { CbLogin } from "./CbLogin/CbLogin";
import FeaturedProductsContainer from "./FeaturedItemSection/FeaturedProductsContainer";
import PluginSlotContainer from "../layouts/PluginSlotContainer";
import TargeterContainer from "./TargeterContainer/TargeterContainer";
import MainStaticTitle from "./MainStaticTitle";
import HeaderNavContainer from "../layouts/HeaderNavContainer";
import HeaderNavTabContainer from "./HeaderNavTabContainer/HeaderNavTabContainer";
import SearchedAdjustment from "./PlpSection/SearchedAdjustment";
import HubSpotPluginForm from "./HubSpotContainer/HubSpotPluginForm";
import InternalFacetsContainer from "./Facets/InternalFacetsContainer";


//const ResultsContainer = lazy(() => import("./PlpSection/ResultsContainer"));
//const BreadCrumbsContainer = lazy(() => import("./BreadCrumbs/BreadCrumbsContainer"));
//const FacetsContainer = lazy(() => import("./Facets/FacetsContainer"));
//const ProductDetailsContainer = lazy(() => import("./PdpSection/ProductDetailsContainer"));

 

 



export class MyComponent extends Component {
  components = {
    OneColumnPage: OneColumnPage,
    CssPage: CssPage,
    TwoColumnPage: TwoColumnPage,
    TwoColumnFullWidthHeaderPage: TwoColumnFullWidthHeaderPage,
    CbHomeTemplate:CbHomeTemplate,
    PageSlotContainer:PageSlotContainer,
    PluginSlotContainer:PluginSlotContainer,
    ArticleContainer: ArticleContainer,
    ContentRuleFolder:ContentRuleFolder,
    SliderContainer: SliderContainer,
    RawHtmlContainer: RawHtmlContainer,
    SliderTestContainer: SliderTestContainer,
    SolutionContainer: SolutionContainer,
    VastPROLogoContainer: VastPROLogoContainer,
    HeaderContainer: HeaderCbOSE,
    CssContent: CssContent,
    FormPlugin: FormPlugin,
    FormTemplatePlugin:FormTemplatePlugin,
    CbLogin: CbLogin,
    CustomSliderContainer: customSliderContainer,
    FooterContainer: FooterContainer,
    ProductDescriptionContainer: ProductDescriptionContainer,
	  CategoryListingContainer: CategoryListingContainer,
    ResultsContainer: ResultsContainer,
    BreadCrumbsContainer: BreadCrumbsContainer,
    ProductDetailsContainer: ProductDetailsContainer,
    FacetsContainer: FacetsContainer,
    CbOSEMainContainer:CbOSEMainContainer,
    HtmlRawContainer:HtmlRawContainer,
    ZeroResultContainer:ZeroResultContainer,
    SelectedCrumbContainer:SelectedCrumbContainer,
    CategoryNameContainer:CategoryNameContainer,
    CategoryFeaturedProductsContainer:FeaturedProductsContainer,
    FeaturedProductsContainer:FeaturedProductsContainer,
    TargeterContainer:TargeterContainer,
    BoostAndBuryFacetsContainer:FacetsContainer,
    BoostAndBuryResultsContainer:ResultsContainer,
	  MainStaticTitle:MainStaticTitle,
    CbHubSpot:HubSpotPluginForm,
    HeaderNavContainer:HeaderNavContainer,
    HeaderNavTabContainer,HeaderNavTabContainer,
    SearchedAdjustmentContainer:SearchedAdjustment,
    InternalFacetsContainer:InternalFacetsContainer
  };

  render() {
    var key = this.components[this.props.type || 'Loader'];
    //console.log('key ----- mycomponant ', key)
    const ComponentName = key ? key : this.components['DefaultPlugin'];
    return (
      <>
        <ComponentName state={this.props.state} containerObject={this.props.containerObject} contentId={this.props.contentId} dataZone="MainContent" templateName={this.props.templateName} parentAttributes={this.props.parentAttributes ? this.props.parentAttributes : ""}  />
      </>
    )
  }
}

export default MyComponent;
